const enchantEnumeration = {
  //Legs

  "+177 Intellect &amp; +133 Stamina": { name: "Frozen Spellthread", id: 194013, Quality: 3, rarity: 3 },
  "+177 Intellect &amp; +131 Stamina": { name: "Frozen Spellthread", id: 194013, Quality: 3, rarity: 3 },
  "+151 Intellect &amp; +111 Stamina": { name: "Frozen Spellthread", id: 194013, Quality: 2, rarity: 3 },
  "+124 Intellect &amp; +92 Stamina": { name: "Frozen Spellthread", id: 194013, Quality: 1, rarity: 3 },

  "+177 Intellect &amp; +5% Mana": { name: "Temporal Spellthread", id: 194016, Quality: 3, rarity: 3 },
  "+151 Intellect &amp; +4% Mana": { name: "Temporal Spellthread", id: 194016, Quality: 2, rarity: 3 },
  "+124 Intellect &amp; +3% Mana": { name: "Temporal Spellthread", id: 194016, Quality: 1, rarity: 3 },

  "+106 Intellect": { name: "Vibrant Spellthread", id: 194010, Quality: 3, rarity: 2 },
  "+90 Intellect": { name: "Vibrant Spellthread", id: 194010, Quality: 2, rarity: 2 },
  "+74 Intellect": { name: "Vibrant Spellthread", id: 194010, Quality: 1, rarity: 2 },

  "+177 Agility/Strength &amp; +131 Stamina": { name: "Fierce Armor Kit", id: 193565, Quality: 3, rarity: 0 },
  "+151 Agility/Strength &amp; +111 Stamina": { name: "Fierce Armor Kit", id: 193565, Quality: 2, rarity: 0 },
  "+124 Agility/Strength &amp; +92 Stamina": { name: "Fierce Armor Kit", id: 193565, Quality: 1, rarity: 0 },

  "+177 Agility/Strength &amp; +141 Armor": { name: "Frosted Armor Kit", id: 193564, Quality: 3, rarity: 0 },
  "+151 Agility/Strength &amp; +120 Armor": { name: "Frosted Armor Kit", id: 193564, Quality: 2, rarity: 0 },
  "+124 Agility/Strength &amp; +99 Armor": { name: "Frosted Armor Kit", id: 193564, Quality: 1, rarity: 0 },

  "+155 Primary Stat &amp; +41 Versatility": { name: "Lambent Armor Kit", id: 204701, Quality: 3, rarity: 0 },
  "+128 Primary Stat &amp; +39 Versatility": { name: "Lambent Armor Kit", id: 204701, Quality: 2, rarity: 0 },
  "+102 Primary Stat &amp; +37 Versatility": { name: "Lambent Armor Kit", id: 204701, Quality: 1, rarity: 0 },

  "+106 Agility/Strength": { name: "Reinforced Armor Kit", id: 193567, Quality: 3, rarity: 0 },
  "+90 Agility/Strength": { name: "Reinforced Armor Kit", id: 193567, Quality: 2, rarity: 0 },
  "+74 Agility/Strength": { name: "Reinforced Armor Kit", id: 193567, Quality: 1, rarity: 0 },

  //Rings
  "+82 Haste": { name: "Devotion of Haste", Quality: 3, rarity: 2 },
  "+73 Haste": { name: "Devotion of Haste", Quality: 2, rarity: 2 },
  "+64 Haste": { name: "Devotion of Haste", Quality: 1, rarity: 2 },
  "+82 Mastery": { name: "Devotion of Mastery", Quality: 3, rarity: 2 },
  "+73 Mastery": { name: "Devotion of Mastery", Quality: 2, rarity: 2 },
  "+64 Mastery": { name: "Devotion of Mastery", Quality: 1, rarity: 2 },
  "+82 Critical Strike": { name: "Devotion of Critical Strike", Quality: 3, rarity: 2 },
  "+73 Critical Strike": { name: "Devotion of Critical Strike", Quality: 2, rarity: 2 },
  "+64 Critical Strike": { name: "Devotion of Critical Strike", Quality: 1, rarity: 2 },
  "+82 Versatility": { name: "Devotion of Versatility", Quality: 3, rarity: 2 },
  "+73 Versatility": { name: "Devotion of Versatility", Quality: 2, rarity: 2 },
  "+64 Versatility": { name: "Devotion of Versatility", Quality: 1, rarity: 2 },
  "+55 Haste": { name: "Writ of Haste", Quality: 3, rarity: 1 },
  "+45 Haste": { name: "Writ of Haste", Quality: 2, rarity: 1 },
  "+35 Haste": { name: "Writ of Haste", Quality: 1, rarity: 1 },
  "+55 Mastery": { name: "Writ of Mastery", Quality: 3, rarity: 1 },
  "+45 Mastery": { name: "Writ of Mastery", Quality: 2, rarity: 1 },
  "+35 Mastery": { name: "Writ of Mastery", Quality: 1, rarity: 1 },
  "+55 Critical Strike": { name: "Writ of Critical Strike", Quality: 3, rarity: 1 },
  "+45 Critical Strike": { name: "Writ of Critical Strike", Quality: 2, rarity: 1 },
  "+35 Critical Strike": { name: "Writ of Critical Strike", Quality: 1, rarity: 1 },
  "+55 Versatility": { name: "Writ of Versatility", Quality: 3, rarity: 1 },
  "+45 Versatility": { name: "Writ of Versatility", Quality: 2, rarity: 1 },
  "+35 Versatility": { name: "Writ of Versatility", Quality: 1, rarity: 1 },
  //Wrist
  "+200 Avoidance": { name: "Devotion of Avoidance", Quality: 3, rarity: 2 },
  "+175 Avoidance": { name: "Devotion of Avoidance", Quality: 2, rarity: 2 },
  "+150 Avoidance": { name: "Devotion of Avoidance", Quality: 1, rarity: 2 },
  "+200 Leech": { name: "Devotion of Leech", Quality: 3, rarity: 2 },
  "+175 Leech": { name: "Devotion of Leech", Quality: 2, rarity: 2 },
  "+150 Leech": { name: "Devotion of Leech", Quality: 1, rarity: 2 },
  "+200 Speed": { name: "Devotion of Speed", Quality: 3, rarity: 2 },
  "+175 Speed": { name: "Devotion of Speed", Quality: 2, rarity: 2 },
  "+150 Speed": { name: "Devotion of Speed", Quality: 1, rarity: 2 },
  "+125 Avoidance": { name: "Writ of Avoidance", Quality: 3, rarity: 1 },
  "+100 Avoidance": { name: "Writ of Avoidance", Quality: 2, rarity: 1 },
  "+75 Avoidance": { name: "Writ of Avoidance", Quality: 1, rarity: 1 },
  "+125 Leech": { name: "Writ of Leech", Quality: 3, rarity: 1 },
  "+100 Leech": { name: "Writ of Leech", Quality: 2, rarity: 1 },
  "+75 Leech": { name: "Writ of Leech", Quality: 1, rarity: 1 },
  "+125 Speed": { name: "Writ of Speed", Quality: 3, rarity: 1 },
  "+100 Speed": { name: "Writ of Speed", Quality: 2, rarity: 1 },
  "+75 Speed": { name: "Writ of Speed", Quality: 1, rarity: 1 },
  //Chest Enchants
  "Primary Stats +30": "Eternal Stats",
  //Waist
  "Shadowed Belt Clasp": { name: "Shadowed Belt Clasp", Quality: 3, rarity: 2 },
};

export function getEnchantName(enchantName) {
  if (typeof enchantName != "undefined") {
    return enchantEnumeration[enchantName] ? enchantEnumeration[enchantName].name : enchantName.replace(/&amp;/g, "&");
  }
}

export function getEnchantRarity(enchantName) {
  return enchantEnumeration[enchantName] ? enchantEnumeration[enchantName].rarity : 3;
}

export function getEnchantQuality(enchantName) {
  return enchantEnumeration[enchantName] ? enchantEnumeration[enchantName].Quality : 3;
}
export function getEnchantQualityIconSrc(enchantName) {
  let enchantQuality = enchantEnumeration[enchantName] ? enchantEnumeration[enchantName].Quality : 3;
  return `https://static.bigbrain.gg/wow/icons/item-quality-icons/crafted-item-quality-${enchantQuality}.png`;
}

export function getEnchantImgLinkSrc(enchantName) {
  return enchantEnumeration[enchantName]?.id
    ? `https://static.bigbrain.gg/wow/item/assets/${enchantEnumeration[enchantName].id}.webp`
    : "https://static.bigbrain.gg/wow/item/assets/200054.webp";
}

export function getEnchantImgId(enchantName) {
  return enchantEnumeration[enchantName]?.id ? enchantEnumeration[enchantName].id : 200054;
}

export function trimQuality(enchantName) {
  if (typeof enchantName != "undefined" && enchantName.includes("Quality")) {
    let qualityCropIndex = enchantName.indexOf("Quality");
    return enchantName.slice(0, qualityCropIndex);
  } else {
    return enchantName;
  }
}
